import React, { useEffect, useState } from "react";
import { DocumentoService, PlanoService } from "./../../services";
import {
  DocumentoEntidade,
  DocumentoPastaEntidade,
  PlanoVinculadoEntidade,
} from "./../../entidades";
import { useHistory } from "react-router-dom";

import {
  Alert,
  Box,
  Col,
  Row,
} from "@intech/web-ui";
import { CenteredRow, SmallButton, LinkPastaAtual, Label } from "./styles";
import { FaChevronLeft } from "react-icons/fa";
import { ListaPasta } from "./ListaPasta";
import { ListaDocumento } from "./ListaDocumento";
import { Opcoes } from "./Opcoes";
import { NumFuncionalidade } from "../../helpers/BloqueioFuncionalidade";
import { LoadingComponent, MasterPage } from "@components";

interface IProps {
  match?: any;
}

export const Documentos: React.FC<IProps> = ({
  match,
  ...props
}) => {
  const history = useHistory();

  const options = ["data", "nome"];

  const [AlertText, setAlertText] = useState<string>("");
  const [Documentos, seTDocumentos] = useState<Array<DocumentoEntidade> | null>(null);
  const [OidPasta, setOidPasta] = useState<number>(0);
  const [Pastas, setPastas] = useState<Array<DocumentoPastaEntidade> | null>(null);
  const [PastaAtual, setPastaAtual] = useState<DocumentoPastaEntidade>();
  const [PastaPai, setPastaPai] = useState<DocumentoPastaEntidade>();
  const [Planos, setPlanos] = useState<Array<PlanoVinculadoEntidade>>(new Array<PlanoVinculadoEntidade>());
  const [cdPlano, setCdPlano] = useState<string>("");
  const [SelectedOption, setSelectedOption] = useState<string>(options[0]);

  useEffect(() => {
    (async () => {
      try {
        const planos = await PlanoService.Buscar();

        setPlanos(planos);
        setCdPlano(planos[0].CD_PLANO);
        // await BuscarLista(planos[0].CD_PLANO);
      }
      catch (err) {
        if (err.message.indexOf("401") > -1) {
          history.push("/login");
        }
      }
    })();
  }, []);

  useEffect(() => {
    setOidPasta(match.params.pasta ?? 0);
  }, [match]);

  useEffect(() => {
    (async () => {
      if (cdPlano) {
        await BuscarLista(cdPlano);
      }
    })();
  }, [OidPasta, cdPlano, SelectedOption]);

  function HandleOptionChange(e) {
    const selectedOption = e.target.value;
    setSelectedOption(selectedOption);
    BuscarLista();
  };

  async function BuscarLista(CD_PLANO = "") {
    try {
      const resultado = await DocumentoService.BuscarPorPlanoPasta(
        CD_PLANO || Planos[0].CD_PLANO,
        OidPasta,
        SelectedOption
      );

      seTDocumentos(resultado.documentos);
      setPastas(resultado.pastas);
      setPastaAtual(resultado.pastaAtual);
      setPastaPai(resultado.pastaPai);
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      setAlertText(error);
    }
  }

  function Voltar() {
    const destino = "/documentos/" + (PastaPai ?
      PastaPai!.OID_DOCUMENTO_PASTA : "");
    // history.push(destino);
    return destino;
  }

  function renderPastaDocumentosTabela() {
    if (Pastas === null || Documentos === null) {
      return (
        <LoadingComponent />
      );
    }

    if (Pastas.length === 0 && Documentos.length === 0) {
      return (
        <Alert type={"danger"}>
          {"Nenhum item disponível."}
        </Alert>
      );
    }

    return (
      <div className={"table-responsive"}>
        <table className={"table table-striped table-sm"}>
          <tbody>
            <ListaPasta pastas={Pastas} />
            <ListaDocumento documentos={Documentos} />
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.DOCUMENTOS} {...props}>
      <Box title={"Pastas e Arquivos Disponibilizados"}>
        <Col>
          <Row className={"mb-2"}>
            <Col>
              <Row>
                <Label>
                  {"Ordenar Por:"}
                </Label>
              </Row>
              <CenteredRow>
                <Opcoes
                  options={options}
                  SelectedOption={SelectedOption}
                  HandleOptionChange={HandleOptionChange}
                />

                {PastaAtual && (
                  <>
                    <SmallButton to={Voltar}>
                      <FaChevronLeft /> Voltar
                    </SmallButton>

                    <LinkPastaAtual>
                      {`Pasta atual: ./${PastaPai
                        ? PastaPai.NOM_PASTA + "/"
                        : ""
                        }${PastaAtual.NOM_PASTA}`}
                    </LinkPastaAtual>
                  </>
                )}
              </CenteredRow>
            </Col>
          </Row>

          {AlertText !== "" &&
            <Alert type={"danger"}>
              {AlertText}
            </Alert>
          }

          {renderPastaDocumentosTabela()}
        </Col>
      </Box>
    </MasterPage>
  );
}
